import React from "react";
import { Camera } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import Gallery from "@/components/Gallery";
import SocialMediaHub from "@/components/SocialMediaHub";
import { useLang } from "@/context/LanguageContext";


export default function Media() {
    const { t } = useLang();

  return (
    <div data-testid="media-page" className="min-h-screen bg-sand text-jungle">
      {/* Ajuste as props abaixo caso seu componente <SEO /> use nomes diferentes */}
      <SEO
        title="Social Media and Gallery | Paraglide Tandem in Costa Rica and more"
        description="Follow our social media profiles and view the photo gallery of paragliding flights in Rivas and Dominical, Costa Rica."
      />
      <Header />

      <main>
        <SocialMediaHub />

        <section className="border-t border-jungle/10 px-6 py-20 md:py-28">
          <div className="mx-auto max-w-5xl text-center">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#3E8FB0]">
              <Camera className="h-4 w-4" /> {t.nav.gallery}
            </span>
            <h2 className="mt-3 text-3xl font-bold tracking-tight md:text-5xl">
              {t.social.h2}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-jungle/70">
             {t.social.paragraph}
            </p>
          </div>

          <div className="mt-12">
            <Gallery />
          </div>

          <p className="mt-10 text-center text-sm text-jungle/60">
            Flew with us? Tag us.{""}
            <a
              href="https://www.instagram.com/paragliding_costa_rica/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-jungle underline underline-offset-4"
            >
              @paragliding_costa_rica
            </a>{" "}
            in your photos to appear in our galleries.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}